import React from "react";
import { getCurrencyAmount } from "../../helpers/helpers";
import P from "../../shared/typography/P";

const LeaseSection = ({ leaseRental, billWithSolar }) => {
    const billWithSolarStr = billWithSolar?.replace(/[^0-9]/g, "");
    const leaseRentalStr = leaseRental?.replace(/[^0-9]/g, "");
    const savings = Number(billWithSolarStr) - Number(leaseRentalStr);
    const savingPercentage = (savings * 100) / billWithSolarStr;
    const savingInFiveYears = savings * 60;

    const lifetimeSavings =
        savingInFiveYears + Number(billWithSolarStr) * 12 * 20;
    return (
        <div className="flex flex-col gap-2">
            <div className="bg-linear-blue-white no-bg-image md:bg-primary  p-1 rounded-2xl flex justify-between items-center">
                <P className="text-white">Monthly Lease Payment</P>
                <P className="text-white text-nowrap font-semibold">
                    ₹{leaseRental}
                </P>
            </div>
            <div className="flex flex-nowrap items-center justify-center gap-2.5">
                <div className="flex w-full lg:w-auto flex-col gap-1 items-center justify-center p-1 xs:p-1.8 rounded-2xl bg-gray-200">
                    <P className="font-medium text-sm text-nowrap">
                        ₹ {savings.toLocaleString()} (
                        {savingPercentage.toFixed(0)}%)
                    </P>
                    <P className="font-thin text-xs xl:text-sm">
                        Monthly Savings
                    </P>
                </div>
                <div className="flex w-full  lg:w-auto flex-col gap-1 items-center justify-center p-1 xs:p-1.8 rounded-2xl bg-gray-200">
                    <P className="font-medium text-sm text-nowrap">
                        {getCurrencyAmount(savingInFiveYears)}
                    </P>
                    <P className="font-thin text-xs xl:text-sm">
                        Savings in 5 Years
                    </P>
                </div>
            </div>

            <div className=" bg-linear-blue-white p-1 rounded-2xl flex justify-center items-center">
                <P className="text-white font-medium md:text-sm lg:text-sm xl:text-sm">
                    Lifetime savings with solar{" "}
                    {getCurrencyAmount(lifetimeSavings)}
                </P>
            </div>
        </div>
    );
};

export default LeaseSection;
